import AudioManager from 'scripts/util/AudioManager';
import AssetLoader from "../loaders/AssetLoader";
import * as BABYLON from 'babylonjs'

class Snowball {
  constructor (template) {
    const index =  Math.round(Math.random() * 1000)
    this.view = new BABYLON.TransformNode('Snowball' + index)
    this.view.rotationQuaternion = null

    this.isHit = false

    this.snowballTemplate = template;
    this.snowballTemplate.rootNodes[0].getChildMeshes().forEach((mesh)=> {
      mesh.isPickable = false;
    })
    this.snowball = this.snowballTemplate.instantiateModelsToScene((name) => "SB_" + name);
    this.snowball.rootNodes[0].parent = this.view;
    this.snowball.rootNodes[0].position.y = 0.25

    this.collider = BABYLON.MeshBuilder.CreateBox("SnowballCollider" + index, {width: 1.5, size: 1.2});
    this.collider.position.y = .5
    this.collider.parent = this.view
    this.collider.isVisible = false

    this.particleSystem = new BABYLON.GPUParticleSystem(
      "SnowballParticles" + index,
      20
    );
    this.particleSystem.particleTexture = AssetLoader.getTexture("PresentSparks").clone();
    this.particleSystem.endSpriteCellID = 2;
    this.particleSystem.startSpriteCellID = 0;
    this.particleSystem.spriteCellHeight = 128;
    this.particleSystem.spriteCellWidth = 128;
    this.particleSystem.spriteRandomStartCell = true;
    this.particleSystem.isAnimationSheetEnabled = true;
    this.particleSystem.minLifeTime = 0.2;
    this.particleSystem.maxLifeTime = 1;
    this.particleSystem.emitRate = 3;
    this.particleSystem.isLocal = true;
    this.particleSystem.minSize = 0.2;
    this.particleSystem.maxSize = 0.4;
    this.particleSystem.minLifeTime = 1;
    this.particleSystem.maxLifeTime = 1.5;
    this.particleSystem.color1 = new BABYLON.Color4(1, 1, 1, 0);
    this.particleSystem.color2 = new BABYLON.Color4(1, 1, 1, 1);
    this.particleSystem.colorDead = new BABYLON.Color4(1, 1, 1, 0);
    this.particleSystem.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD;
    this.particleSystem.particleEmitterType.directionRandomizer = 1;
    this.particleSystem.direction1 = new BABYLON.Vector3(0.2, 0.5, 0);
    this.particleSystem.direction2 = new BABYLON.Vector3(-0.2, 0.5, 0);
    this.particleSystem.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;

    this.meshEmitter = BABYLON.MeshBuilder.CreateBox("snowballEmitter", {
      height: 1,
      width: 1,
      depth: 1,
    });
    this.meshEmitter.position.y = 0.4;
    this.snowball.rootNodes[0].addChild(this.meshEmitter);
    this.meshEmitter.isVisible = false;
    this.meshEmitter.isBlocker = false;
    this.particleSystem.emitter = this.meshEmitter;
    this.particleSystem.start();
    this.particleSystem.parent = this.snowball.rootNodes[0];
  } 

  setConfig(config) {
    this.config = config
    
    const {position, rotation, scaling} = this.config
    
    this.view.rotation = rotation.clone()
    this.view.position = position.clone()
    this.view.scaling = scaling.clone()
  }

  hit () {
    this.isHit = true
    this.snowball.rootNodes[0].getChildMeshes()[0].isVisible = false;
    this.particleSystem.stop();
    this.particleSystem.reset();
    AudioManager.playSound("snowball");
  }

  reset () {
    this.snowball.rootNodes[0].getChildMeshes()[0].isVisible = true;
    this.isHit = false
  }

  update () {
    if (this.isHit === false) {
      this.view.rotation.y += .05
    }
  }

  destroy() {
    this.collider.parent = null
    this.collider.isVisible = false
    this.collider.dispose()

    this.snowball.parent = null
    this.snowball.rootNodes[0].getChildMeshes()[0].isVisible = false;

    this.view.parent = null
    this.view.isVisible = false
    this.view.dispose()

    this.particleSystem.stop();
  }
}

export default Snowball